define('flight-components/SurveyToolbar',[
  'App',
  'flight/lib/component',
  'cookies'
],
function (App, defineComponent) {

  var SurveyToolbar = function SurveyToolbar() {

    this.defaultAttrs({
      continueButtonSelector: '.survey-toolbar__continue-btn',
      dismissButtonSelector: '.survey-toolbar__dismiss-btn'
    });

    this.incrementClickCount = function(ev, data) {

      this.attr.actionClickCookie = $.cookie('actionclick');
      if (!this.attr.actionClickCookie) {
        // Cookie not present, create one
        $.cookie('actionclick', 1, {path:'/'});
      }
      else {
        // Cookie present, increment it
        this.attr.actionClickCookie++;
        $.cookie('actionclick', this.attr.actionClickCookie, {path:'/'});
      }
    };

    this.continueSurvey = function (ev, data) {
      // Set survey cookie
      $.cookie('survey', true, {expires:365, path:'/'});

      // Init survey
      window.open(App.user.surveyUrl);

      this.$node.remove();
      this.teardown();
    };

    this.dismissSurvey = function (ev, data) {
      // Set survey cookie
      $.cookie('survey', true, {expires:90, path:'/'});

      this.$node.remove();
      this.teardown();
    };

    this.after('initialize', function() {

      var self = this;
      this.on('click', {
        'continueButtonSelector': this.continueSurvey,
        'dismissButtonSelector': this.dismissSurvey
      });

      this.on(document, 'ui-increment-action-count-requested', this.incrementClickCount);

    });

  };

  return defineComponent(SurveyToolbar);
});
